module.exports = __webpack_public_path__ + "img/become_a_game_designer_splash.4dc61b22.jpg";